import { Flex, NavLink, Progress, Title, Text, useMantineTheme } from "@mantine/core";
import { TModule, TEnrollmentProgress, TProgress } from "../../types/Aula";
import { notifications } from "@mantine/notifications";
import { IconPercentage50 } from "@tabler/icons-react";
import { FaCheck, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { closeDrawer } from "../../store/slices/drawerSlice";

export const Outline = ({
    enrollment,
    progress,
    lessonId,
}: {
    enrollment: TEnrollmentProgress | null;
    progress: TProgress[];
    lessonId: string;
}) => {
    const theme = useMantineTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <Flex
            direction="column"
            w="100%"
            p="xl"
            style={{
                borderRight: "1px solid #e0e0e0",
            }}
        >
            <Title size="lg" order={4} mb="lg">
                {enrollment?.course.name}
            </Title>
            <Progress
                value={enrollment?.percentage_completed ?? 0}
                size="sm"
                color="blue"
                mb="xs"
                h="10px"
            />
            <Text
                size="md"
                c="black"
                ta="center"
                style={{
                    borderBottom: "1px solid #e0e0e0",
                    paddingBottom: "0.5rem",
                }}
            >
                {enrollment?.percentage_completed}% completado
            </Text>
            {enrollment?.course.modules.map((module: TModule) => (
                <NavLink
                    key={module.id}
                    label={
                        <Title size="md" order={6} ta="justify">
                            {module.name}
                        </Title>
                    }
                    defaultOpened
                >
                    {module.lessons.map((lesson: any) => (
                        <NavLink
                            key={lesson.id}
                            label={
                                <Flex gap="xs" align="center">
                                    <Flex>
                                        {progress
                                        .filter((p) => p.lesson === lesson.id)
                                        .map((p) =>
                                            p.completed_at ? (
                                            <FaCheck
                                                size={16}
                                                color={theme.colors["genderlab-red"][6]}
                                                key={p.id}
                                            />
                                            ) : p.is_accesible ? (
                                            <IconPercentage50
                                                size={16}
                                                key={p.id}
                                                style={{ color: theme.colors["genderlab-red"][6] }}
                                            />
                                            ) : (
                                            <FaLock
                                                size={16}
                                                key={p.id}
                                                color={theme.colors.gray[5]}
                                            />
                                            )
                                        )}
                                    </Flex>
                                    <Text
                                        size="sm"
                                        fw={lesson.id === lessonId ? 600 : 400}
                                        ta="justify"
                                        c="black"
                                    >
                                        {lesson.name}
                                    </Text>
                                </Flex>
                            }
                            active={lesson.id === lessonId}
                            onClick={() => {
                                if (
                                    progress.find((p) => p.lesson === lesson.id)?.is_accesible
                                ) {
                                    navigate(
                                        `/aula-virtual/${enrollment.id}/content/${lesson.id}`,
                                        {
                                            state: { category: lesson.category },
                                        }
                                    );
                                    dispatch(closeDrawer());
                                } else {
                                    notifications.show({
                                        title: "Clase bloqueada",
                                        message:
                                        "Completa las clases anteriores para acceder a esta clase.",
                                        position: "bottom-right",
                                        color: "yellow",
                                        autoClose: 5000,
                                        icon: <FaLock />,
                                        withBorder: true,
                                    });
                                }
                            }}
                        />
                    ))}
                </NavLink>
            ))}
        </Flex>
    );
};